import React, { Component } from 'react';
import { connect } from 'react-redux';
import { GithubPicker } from 'react-color';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import './PageBackgroundColor.css';
import { loadCoverToBGType } from '../../../../../redux/actions/ui/loadFirstCoverToBackgroundType';
import {
  changePagesBackgroundColor,
  changePageBackgroundColorById } from './../../../../../redux/actions/entities/pages';
import { changeBookBackgroundColor, changeBookBackgroundType } from './../../../../../redux/actions/ui/bookProperties';
import { saveState } from './../../../../../redux/actions/entities/io';
import Item from './Item';
import Lightbox from './../../../../lightbox/Lightbox';
import PageBackgroundImage from './../page-background-image/PageBackgroundImage';
import ParentCategory from './parent-category/ParentCategory';
import {
  getLang,
  getDomain } from './../../../../../redux/helpers/getParams';
import { configExist, getCoverOrientation, MmToPx } from './../../../../../redux/helpers';
import loadProCoverTemplates from './../../../../../config/templates/covers/pro';
import loadConsumerCoverTemplates from './../../../../../config/templates/covers/consumer';
import {
  loadLayouts,
  removeDefaultLayout } from './../../../../../redux/actions/entities/layouts';
import { setFirstLayout } from './../../../../../redux/helpers/loadDefaulState';
import loadConsumerBelivTemplates from './../../../../../config/templates/layouts/consumer';

import { updateCoverSizes, updateCoverMarginSize } from '../../../../../redux/actions/bookproperties';
import { CALLIGRAFIA, MODERN } from '../../../../../helpers/coverHelper';

class PageBackgroundColor extends Component {
  constructor(args) {
    super(args);
    this.state = {
      backgroundColor: '#FFFFFF',
      backgrounds: null,
      selectedId: '',
      selectedCategory: '',
      lightboxOpened: false,
      thumbnailUrl: '',
      removeBackButton: false,
      galleryImages: [],
      imageIndex: 0,
    };
  }

  componentDidMount() {
    const referer = getDomain();
    const backgroundApiURL = configExist('backgroundApiURL', referer);
    const backgroundService = `${backgroundApiURL}/${getLang()}`;

    fetch(backgroundService, {
      cors: 'no-cors',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      credentials: 'include',
    })
      .then(response => response.json())
      .then((backgrounds) => {
        this.setState({
          backgrounds,
        });
      });
  }


  componentDidUpdate(prevProps) {
    const { allIds, isBabyBook } = prevProps;
    const {
      allIds: current,
      backgroundType: currentBg,
      coverType,
      dimensions,
      loadCoverDependOnBgType,
      context,
      pages,
      pageId,
      isBabyBook: currentBabyBook,
    } = this.props;
    const { pageWidth, pageHeight } = dimensions;

    const format = getCoverOrientation(pageWidth, pageHeight);
    const coverTemplates = this.props.context === 'consumer' ? loadProCoverTemplates[format][coverType.type] : loadConsumerCoverTemplates[format][coverType.type];
    if (!coverTemplates) {
      return null;
    }
    const selectedCover = coverTemplates.sizes.filter(element => element.label === coverType.label);

    const defaultBackgroundType = context === 'consumer' ? 'modern' : 'tematikus';

    if ((allIds.length !== current.length) && (currentBg === defaultBackgroundType) && (format !== 'landscape')) {
      this.props.dispatch(loadLayouts(selectedCover));

      const hasLayout = pages[pageId] ? pages[pageId].layout : 10;
      this.props.dispatch(removeDefaultLayout(hasLayout));
      this.props.dispatch(loadCoverToBGType('loading'));
    }

    if ((currentBg === defaultBackgroundType) && (loadCoverDependOnBgType === 'loading') && (format !== 'landscape')) {
      const getCover = selectedCover.find(element => !element.only_autofill_layout);
      this.props.dispatch(updateCoverMarginSize(getCover.margin));
      setFirstLayout(this.props, getCover.id, 10);
      const { width, height } = getCover;
      this.props.dispatch(updateCoverSizes(
        width,
        height,
        MmToPx(width),
        MmToPx(height),
      ));
      this.props.dispatch(loadCoverToBGType('loaded'));
    }

    if (isBabyBook !== currentBabyBook && currentBabyBook) {
      //this.props.dispatch(changeBookBackgroundType('tematikus'));
      this.loadSelectedBelivLayouts();
      this.setState({
        selectedCategory: 'Baby',
        removeBackButton: true,
      });
    }
  }


  setLightbox = () => {
    this.setState({
      lightboxOpened: false,
      thumbnailUrl: '',
      galleryImages: [],
      imageIndex: 0,
    });
  }

  loadSelectedBelivLayouts = () => {
    const { dimensions } = this.props;
    const format = getCoverOrientation(dimensions.pageWidth, dimensions.pageHeight);
    const pageType = loadConsumerBelivTemplates;
    const layoutTemplates = pageType[format];
    for (const layout of layoutTemplates.items) {
      this.props.dispatch(loadLayouts(layout.layouts));
    }
  }

  handleBackgroundChange = (color) => {
    this.handleUserAction(color.hex);
  };

  openLightBox = (imageUrl, galleryImages, imageIndex) => this.setState({
    lightboxOpened: true,
    thumbnailUrl: imageUrl,
    galleryImages,
    imageIndex,
  })

  handleUserAction(color) {
    const {
      lang,
      isBabyBook,
      pages,
      pageId,
      pageOrder,
      backgroundType,
      coverType,
    } = this.props;

    const bookPages = pages.length;
    if (isBabyBook || bookPages === 1) {
      return this.props.dispatch(changeBookBackgroundColor(color));
    }

    Swal({
      text: lang.color_change_question,
      type: 'question',
      showCancelButton: true,
      confirmButtonText: lang.from_current,
      cancelButtonText: lang.from_first,
    }).then((result) => {
      this.props.dispatch(changeBookBackgroundColor(color));
      if (result.value) {
        // Set calligrafia background  black color to white
        if( pageOrder === 0 && backgroundType === MODERN && coverType.type === CALLIGRAFIA){
          this.props.dispatch(changePageBackgroundColorById(pageId, pageOrder, '#ffffff'));
        } else {
          this.props.dispatch(changePageBackgroundColorById(pageId, pageOrder, color));
        }

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.props.dispatch(changePagesBackgroundColor(color, coverType.type, backgroundType));
      }
      this.props.dispatch(saveState());
    });
  }

  githubColorPicker = (backgroundColor, handler) => (
    <GithubPicker
      triangle="hide"
      color={backgroundColor}
      colors={['#FFFFFF', '#000000']}
      onChange={handler}
    />
  )

  toggleList = (e, name) => {
    this.setState(({
      selectedCategory: name,
    }));
  }

  resetCategory = () => {
    this.setState({
      selectedCategory: '',
    });
  }

  toggleImages = (e, sublistIndex) => {
    this.setState({
      selectedId: sublistIndex,
    });
  }

  backgroundList = (data) => {
    const children = (items) => {
      if (items) {
        return items.map((element, index) => (<li
          className="bgDropdown "
          onKeyDown={() => {}}
          role="presentation"
          key={`BgItem-${index}`}
        >
          <PageBackgroundImage
            thumbnail={element.thumbnailUrl}
            full={element.fullUrl}
            src={element.previewUrl}
            lang={this.props.lang}
            sizes={{
                width: element.sizes !== undefined ? element.sizes.width : 0,
                height: element.sizes !== undefined ? element.sizes.height : 0,
              }}
          />
          <i
            className="fa fa-search lightbox"
            onClick={() => this.openLightBox(element.thumbnailUrl, items, index)}
            onKeyDown={() => {}}
            role="presentation"
          />
                                              </li>));
      }
    };

    const { selectedCategory, selectedId } = this.state;
    if (selectedCategory !== '') {
      const category = Object.values(data.status).find(element => element.name === selectedCategory);
      if (category !== undefined) {
        return (category.items.map((subcategory, index) => {
          const isActive = selectedId === `sublist-${index}`;
          return (
            <Item
              key={`sublist-${index}`}
              name={subcategory.name}
              isSubcategory="true"
              onClick={e => this.toggleImages(e, `sublist-${index}`)}
              isActive={isActive}
            >
              <ul className={isActive ? 'active' : ''}>
                { children(subcategory.images) }
              </ul>
            </Item>
          );
        }));
      }
    }

    return (data.status.map((node, index) => (
      <Item
        key={`list-${index}`}
        name={node.name}
        onClick={e => this.toggleList(e, node.name)}
        isSubcategory="false"
      />
    )));
  }


  backgroundPicker = () => {
    const {
      removeBackButton, backgrounds, selectedCategory, backgroundColor,
    } = this.state;
    const {
      lang, backgroundType, dimensions, coverType,
    } = this.props;

    const { pageWidth, pageHeight } = dimensions;
    const format = getCoverOrientation(pageWidth, pageHeight);

    if (backgrounds === null) {
      return false;
    }

    if (backgroundType === 'modern' || format === 'landscape') { return this.githubColorPicker(backgroundColor, this.handleBackgroundChange); }
    if (backgroundType === '') { return <ParentCategory dimensions={dimensions} lang={lang} coverType={coverType} />; }


    const displayCategoryName = selectedCategory !== '' ? ` - ${selectedCategory}` : '';
    return (
      <div className="backgroundPicker">
        <div className="header">
          <h2>{lang.background_color} { displayCategoryName } </h2>
          { !removeBackButton && selectedCategory !== '' ?
            <div
              className="back"
              onClick={() => this.resetCategory()}
              onKeyDown={() => {}}
              role="presentation"
            >
              <i className="fa fa-arrow-left" aria-hidden="true" />
              <span>{lang.back}</span>
            </div>
           : ''}

        </div>
        <div className="listBody ">
          <ol>
            { this.backgroundList(backgrounds) }
          </ol>
        </div>
      </div>
    );
  }

  render() {
    const {
      lightboxOpened,
      thumbnailUrl,
      imageIndex,
      galleryImages,
    } = this.state;

    return (
      <div>
        { this.backgroundPicker() }
        {lightboxOpened && <Lightbox
          isForm={false}
          setLightBox={this.setLightbox}
          url={thumbnailUrl}
          imageIndex={imageIndex}
          galleryImages={galleryImages}
        />}
      </div>
    );
  }
}

PageBackgroundColor.defaultProps = {
  lang: {},
  allIds: [],
  pageId: 10,
  pageOrder: 1,
  backgroundType: '',
  context: 'pro',
  dimensions: {},
  dispatch: () => {},
  coverType: {},
  loadCoverDependOnBgType: '',
  isBabyBook: false,
  pages: [],
};

PageBackgroundColor.propTypes = {
  lang: PropTypes.object,
  pageId: PropTypes.number,
  pageOrder: PropTypes.number,
  backgroundType: PropTypes.string,
  context: PropTypes.string,
  dimensions: PropTypes.object,
  dispatch: PropTypes.func,
  coverType: PropTypes.object,
  loadCoverDependOnBgType: PropTypes.string,
  allIds: PropTypes.array,
  isBabyBook: PropTypes.bool,
  pages: PropTypes.array,
};

export default connect(state => ({
  backgroundType: state.editorUI.bookProperties.backgroundType,
  context: state.bookProperties.context,
  dimensions: state.bookProperties.dimensions,
  coverType: state.bookProperties.cover,
  allIds: state.entities.layouts.allIds,
  loadCoverDependOnBgType: state.editorUI.loadCoverDependOnBgType,
  isBabyBook: state.bookProperties.isBabyBook,
  pages: state.entities.pages.byId,
}))(PageBackgroundColor);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/colors/page-background-color/PageBackgroundColor.jsx